import { render, staticRenderFns } from "./Donor.vue?vue&type=template&id=6961f3d8&scoped=true&lang=pug&"
import script from "./Donor.vue?vue&type=script&lang=ts&"
export * from "./Donor.vue?vue&type=script&lang=ts&"
import style0 from "./Donor.vue?vue&type=style&index=0&id=6961f3d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6961f3d8",
  null
  
)

export default component.exports